/**
 * Turn the raw VITE_APP_CHANGELOG build value (commit messages with escaped
 * `\n` sequences and nested `- - ` bullets) into markdown the Viewer renders.
 * Shared by this build's config/version.ts and the SW's GET_VERSION reply so
 * a waiting worker's release notes get the same treatment.
 */
export function normalizeChangelog(raw: string | undefined): string {
  return (
    raw
      ?.replace(/\\n\\n/g, '\n')
      .replace(/^(##.*)$/gm, '$1\n')
      .replace(/\\n\\n/g, '\\n')
      .replace(/^- - /gm, '- ')
      .replace(/^- /gm, '\n- ')
      .replace(/^( +)- /gm, (_, sp) => sp.replace(/ {2}/g, '    ') + '- ') ||
    'No changelog available'
  );
}
